module.exports = __webpack_public_path__ + "img/dbapp_rcyw.3377a1f1.png";